import React from 'react';

import {GetAnalysisFile} from 'analysis-tool/AnalysisTypes';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import Chip, {ChipSize} from 'ui-library/chips/Chip';

interface ExternalFileChipProps {
  file: GetAnalysisFile;
}

export default function ExternalFileChip({file}: ExternalFileChipProps): JSX.Element {
  async function handleClick(): Promise<void> {
    const signedURL = await performSignedFileQuery(file.externalFileId!, file.downloadUrl!, file.id);
    if (signedURL == null) {
      return;
    }
    window.open(signedURL, '_blank', 'noopener noreferrer');
  }

  return (
    <Chip
      className="chip-container"
      icon={ModelTypeConstants.EXTERNAL_FILE}
      onClick={handleClick}
      size={ChipSize.SMALL}
      text={file.filename}
    />
  );
}
